export const MapIcon = {
  STRATEGY: 'STRATEGY',
  DESTINATION_PATTERN: 'DESTINATION_PATTERN',
};
